const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownArrowNew(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "down-arrow",
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.541,
    height: 6.271,
    viewBox: "0 0 10.541 6.271",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_409",
    d: "M6 9l3.856 3.856L13.713 9",
    "data-name": "Path 409",
    transform: "translate(-4.586 -7.586)",
    style: {
      fill: "none",
      stroke: "#12203c",
      strokelinecap: "round",
      strokeLinejoin: "round",
      strokewidth: 2
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrowNew);
export default __webpack_public_path__ + "static/media/downArrowNew.91989e88fbd267c0cb125fdad67b4b7b.svg";
export { ForwardRef as ReactComponent };